
export const HT3_HOST = 'https://hub.globalhighlights.com/ht3.0'
const __BUILD_VERSION__ = `__BUILD_VERSION__`.replace(/"/g, '')
export const BUILD_VERSION = process.env.NODE_ENV === 'production' ? __BUILD_VERSION__ : process.env.NODE_ENV;

// 应用的配置信息
export const urlParams = new URLSearchParams(window.location.search);
export const CORP_ID = 'ding48bce8fd3957c96b' || '你的企业corpId'; // 企业ID
export const AGENT_ID = '3974171291'; // 从钉钉开放平台获取
export const CLIENT_ID = 'dingv0bqvmquaicustuz';
export const APP_KEY = 'dingv0bqvmquaicustuz';
export const APP_SECRET = 'GT-lsu-1G73uis-nbTOJGkhC4lMfy-Zj9gx2W_ElG__RWuneNLTz3BZkDv5YI1WM5APTx9L';
export const CHATDATA = [{chatId:"chat61cd030577032b9d6d22693aae6a615d",openConversationId: "ciduxrYgrgP9R7zQSvqwz498g==",title: "桂林海纳国际旅行社有限公司"}]
export const API_BASE_URL = 'https://value.hainatravel.com/ht3/value';
